import { ICourse } from '@/types/course'
import { EducationProviderPanel } from './CourseEducationProviderPanel'
import { useTranslations } from 'next-intl'

type CourseEducationProviderProps = {
  courseInfo: Pick<ICourse, 'educationProvider'>
} & React.HTMLAttributes<HTMLDivElement>

export function CourseEducationProvider({
  courseInfo,
  ...props
}: CourseEducationProviderProps) {
  const t = useTranslations('CoursePage')
  const { educationProvider } = courseInfo || {}

  if (
    !educationProvider ||
    !educationProvider?.name ||
    !educationProvider?.bio
  ) {
    return null
  }

  return (
    <div {...props} className={`${props.className}`}>
      <h2 className="text-sm font-normal leading-6 uppercase text-gray-light font-title">
        {t('your_education_provider')}
      </h2>
      <EducationProviderPanel
        className="flex flex-col gap-6 !px-5 !py-4 mt-9 md:mt-4"
        courseInfo={{ educationProvider }}
      />
    </div>
  )
}
